export function extractSlugFromURL(url: string): string {
    const parts = url.replace(/^\/|\/$/g, '').split('/');
    const lastPart = parts[parts.length - 1];
    return lastPart.replace(/^\d+-/, '');
}
